import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sharedGet } from '../lib/api';

/**
 * Loads a public menu tree for the current SnappiPit UI language.
 * Menu types: header | footer | mobile | provider_web | provider_mobile.
 */
export function useMenu(menuType) {
  const { i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const language = String(i18n.resolvedLanguage || i18n.language || 'en')
    .split('-')[0].split('_')[0].toLowerCase();

  useEffect(() => {
    if (!menuType) { setLoading(false); return undefined; }
    let cancelled = false;
    setLoading(true);
    sharedGet(`/menus/${menuType}`, { params: { language } }, 60_000)
      .then((res) => {
        if (!cancelled) setItems(res.data?.items || []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [menuType, language]);

  return { items, loading };
}
